import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const numeric = new Quantity(
    quantityId.NUMERIC,
    'Numeric'
);

numeric.registerUnit(
    new Unit(
        'numeric', 1, 'numeric value', [
            ""
        ]
    )
);

numeric.registerUnit(
    new Unit(
        'percent', 1, 'parts per hundred', [
            "%", 'pct', '&#37;', '&percnt;'
        ]
    )
);

numeric.registerUnit(
    new Unit(
        'permille', 1, 'parts per thousand', [
            "‰", '&#8240;', '&permil;'
        ]
    )
);

numeric.registerUnit(
    new Unit(
        'basispoint', 1, 'parts per ten thousand', [
            "‱", 'bp', 'bip', '&#8241;'
        ]
    )
);

export default numeric;